import { makeStyles } from '@mui/styles';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const useStyles = makeStyles((theme: any) => ({
  wrapper: {
    paddingRight: '14px',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.icon,
    justifyContent: 'space-between',
    gap: '12px',
    width: '100%',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  label: {
    fontWeight: 600,
    textDecoration: 'underline'
  }
}));
